var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"id":"modal-about","centered":"","header-bg-variant":"light","hide-footer":"","scrollable":"","size":"lg","title":"About"}},[_c('VueShowdown',{attrs:{"markdown":_vm.about_file_content}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }